// Home page constants and data

export const ECOSYSTEM_DATA = [
  {
    title: "Student & Industry Convention",
    text: "Ireland's flagship aviation and aerospace careers event connecting thousands of students with employers, educators and industry leaders.",
  },
  {
    title: "Afterburner Networking",
    text: "Networking events bringing professionals, educators and government together to discuss the future of aviation and aerospace.",
  },
  {
    title: "Industry Network",
    text: "A collaborative community supporting workforce development through partnerships, workshops and shared initiatives.",
  },
];

export const HIGHLIGHTS = [
  "8,000+ Students In Person",
  "10,000+ Live Stream Viewers",
  "Aviation & Aerospace Careers",
  "Industry Speakers",
  "Interactive Experiences",
  "Future Technologies",
];

export const ACTION_LINKS = [
  { label: "Become a Speaker", to: "/exhibitorRegistration" },
  { label: "Explore Partnerships", to: "/exhibitorRegistration" },
  { label: "Join Industry Network", to: "/avConNetwork" },
];

export const HOME_CONFIG = {
  heroTitle:
    "Connecting Industry. Inspiring Talent. Shaping Tomorrow's Workforce.",
  heroSubtitle:
    "Ireland's aviation and aerospace ecosystem bringing together industry, education and government to create opportunities, inspire careers and build the workforce of the future.",
  heroMobileTitle: "AvCon 2026",
  heroMobileSubtitle:
    "Connecting students, industry and the future of aviation.",
  buttonText: "Schools Pre-Register 2027",
};
